import React, {useContext, useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PropTypes from 'prop-types';
import Form from "react-bootstrap/Form";
import {Link} from "react-router-dom";
import {
    user_confirm_password,
    user_set_password,
} from "./../../common/BackendConnections";
import AuthContext from "../../store/auth-context";

const passwordPattern = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[(@$!%*?&)])[A-Za-z\\d(@$!%*?&)]{8,}$";

function isEmpty(value) {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
}

const ChangePassword = (props) => {
    const { show, handleFormExit } = props
    const [ validated, setValidated ] = useState(false);
    const [ message, setMessage ] = useState({text:'', isError: false});
    const [ currentPassword, setcurrentPassword ] = useState('');
    const [ newPassword, setnewPassword ] = useState('');
    const [ repeatNewPassword, setrepeatNewPassword ] = useState('');
    const [ isFormDisabled, setIsFormDisabled ] = useState(false);
    const [ isCancelDisabled, setIsCancelDisabled ] = useState(false);
    const [ showPassword, setShowPassword ] = useState(false);
    const [ isPasswordConfirmed, setisPasswordConfirmed ] = useState(false);

    const userFormRef = useRef();

    const authCtx = useContext(AuthContext);

    const handleUpdateCurrentPassword = (e) => {
        e.preventDefault();
        setcurrentPassword(e.target.value);
    }
    const handleUpdateNewPassword = (e) => {
        e.preventDefault();
        setnewPassword(e.target.value);
    }
    const handleUpdatRepeatNewPassword = (e) => {
        e.preventDefault();
        setrepeatNewPassword(e.target.value);
    }

    const handleShowPassword = (e) => {
        setShowPassword(e.target.checked);
    }

    const handleCancelEvent  = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleFormExit();
    };

    const handleClearEvent = () => {
        setcurrentPassword('');
        setnewPassword('');
        setrepeatNewPassword('')
        setisPasswordConfirmed(false)
        setValidated(false);
        setMessage({text: '', isError: false});

        userFormRef.current.reset();
    };

    const handleSubmitEvent = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;

        if (isEmpty(currentPassword) &&
            isEmpty(newPassword) &&
            isEmpty(repeatNewPassword)) {
            setMessage({text: 'Error: All Passwords are empty.', isError: true});
            return
        }

        if ( !isPasswordConfirmed && currentPassword !== '') {
            user_confirm_password(currentPassword).then((response) => {
                if (response.data === true) {
                    setcurrentPassword(currentPassword)
                    setisPasswordConfirmed(true)
                } else {
                    setMessage({text: 'Error: Current Password is not Matching.', isError: true})
                }
            }
            ).catch((error) => {
                console.debug(error);
                setMessage({text: 'Error: Unable to confirm if current password is valid.', isError: true})
                return
            });
        }

        // newPassword validation
        if (newPassword === currentPassword) {
            setMessage({text: 'Error: New Password Must be Different than Current Password.', isError: true})
            return
        }
        else if (newPassword.match(passwordPattern) == null) {
            setMessage({text: 'Error: New Password must contain at least one lowercase letter, ' +
                                    'one uppercase letter, one digit, one special character, and be ' +
                                    'at least 8 characters long.', isError: true});
            return
        }

        // repeatNewPassword validation
        if (repeatNewPassword !== newPassword) {
            setMessage({text: 'Error: Repeat New Password Must Match New Password.', isError: true})
            return
        }
        else if (repeatNewPassword.match(passwordPattern) == null) {
            setMessage({text: 'Error: Repeat New Password must contain at least one lowercase letter, ' +
                                    'one uppercase letter, one digit, one special character, and be ' +
                                    'at least 8 characters long.', isError: true});
            return
        }

        setValidated(true);

        if (form.checkValidity()) {
            user_set_password(newPassword).then((response) => {
                if (response.status === 200) {
                    setMessage({text: 'Updating password...', isError: false}, setTimeout(4000))
                    setIsFormDisabled(true);
                    setIsCancelDisabled(true);
                    handleFormExit()
                    return
                }
            }
            ).catch((error) => {
                console.debug(error);
                setMessage({text: 'Error: unable to set user password.', isError: true})
            });
        }
        else {
            setValidated(false)
            setMessage({text: 'Error: Passwords must contain at least one lowercase letter, ' +
                                    'one uppercase letter, one digit, one special character, and be ' +
                                    'at least 8 characters long.', isError: true});
        }
    };

    return(
        <Modal show={show} size="lg">

            <Modal.Header>
                <h1>{"Change Password"}</h1>
            </Modal.Header>
            <Modal.Body>
                <Form id='user-form' ref={userFormRef} noValidate validated={validated} onSubmit={handleSubmitEvent}>
                    <Form.Group className="mb-3">
                        <Form.Label>User Name:</Form.Label>
                        <Form.Control type="text"
                                      readOnly
                                      disabled
                                      defaultValue={authCtx.userFullName}
                                      autoComplete={"username"} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Current Password:</Form.Label>
                        <Form.Control type={showPassword ? "text" : "password"}
                                      placeholder="Enter Current Password"
                                      defaultValue={currentPassword}
                                      onChange={handleUpdateCurrentPassword}
                                      required={true}
                                      disabled={isFormDisabled}
                                      autoComplete={"off"} />
                    <div className={"text-end"}>
                        <Link to={"/forgotpassword/"}>Forgot Password?</Link>
                    </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>New Password:</Form.Label>
                        <Form.Control type={showPassword ? "text" : "password"}
                                      placeholder="Enter New Password"
                                      defaultValue={newPassword}
                                      onChange={handleUpdateNewPassword}
                                      required={true}
                                      disabled={isFormDisabled}
                                      autoComplete={"new-password"} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Repeat New Password:</Form.Label>
                        <Form.Control type={showPassword ? "text" : "password"}
                                      placeholder="Repeat New Password"
                                      defaultValue={repeatNewPassword}
                                      onChange={handleUpdatRepeatNewPassword}
                                      required={true}
                                      disabled={isFormDisabled}
                                      autoComplete={"off"} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Check type="checkbox" label="Show Password" defaultChecked={showPassword} onChange={handleShowPassword} />
                    </Form.Group>
                </Form>
                <div>
                    {message.text && !message.isError && <div className={"normal_message"}>{message.text}</div> }
                    {message.text &&  message.isError && <div className={"error_message"}>{message.text}</div> }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button color="success" type="submit" form='user-form' disabled={isFormDisabled}>Submit</Button>
                <Button color="failure" onClick={handleCancelEvent} disabled={isCancelDisabled}>Cancel</Button>
                <Button color="failure" onClick={handleClearEvent} disabled={isCancelDisabled}>Clear</Button>
            </Modal.Footer>

        </Modal>
    );
}

ChangePassword.propTypes = {
    show: PropTypes.bool,
    userName: PropTypes.string,
    handleFormExit: PropTypes.func.isRequired,
}

export default ChangePassword;
